<template>
    <v-sheet class="mx-3">
        <v-toolbar elevation="1" dark color="primary">
            <v-toolbar-title>
                Interconsultas
            </v-toolbar-title>
            <v-spacer/>
            <v-btn icon @click="interModal=true" v-if="$store.getters['security/datosUsuario'].roles.includes('ROLE_PACIENTES','ROLE_CONSULTA')">
                <v-icon>
                    mdi-plus
                </v-icon>
            </v-btn>
        </v-toolbar>

        <v-row no-gutters>
            <v-col sm="4" md="3" cols="12">
                <v-sheet class="pa-2 mx-1" elevation="2">
                    <v-date-picker
                    v-model="fechas"
                    class="my-2"
                    range
                    full-width
                    no-title
                    locale="es-mx"
                    scrollable
                    >
                    </v-date-picker>
                    <v-text-field
                            class="my-5"
                            label="Paciente"
                            type="number"
                            min="0"
                        v-model="datosBusqueda.paciente"
                        rounded
                        filled
                        dense
                        clearable
                        hide-details
                    ></v-text-field>
                    <v-text-field
                        class="my-5"
                        label="Folio"
                        v-model="datosBusqueda.folio"
                        rounded
                        filled
                        dense
                        clearable
                        hide-details
                    ></v-text-field>
                    <select-personal
                        label="Médico"
                    ></select-personal>
                    <v-select
                        label="Especialidad"
                        rounded
                        filled
                        dense
                        clearable
                        hide-details
                        :items="$store.state.catalogos.especialidades"
                        item-text="especialidad"
                        item-value="id"
                        @focus="$store.dispatch('catalogos/cargaEspecialidad')"
                    />
                    <v-select
                        label="Estado"
                        class="my-5"
                        v-model="datosBusqueda.status"
                        rounded
                        filled
                        dense
                        clearable
                        hide-details
                        :items="[
                            {value:1, text:'Solicitada'},
                            {value:2, text:'Atendida'},
                            {value:99, text:'Cancelada'},
                        ]"
                    />
                    <v-btn color="error" @click="limpia">
                        Limpiar
                    </v-btn>
                    <v-btn text color="success" @click="filtra">
                        Filtrar
                    </v-btn>
                </v-sheet>
            </v-col>
            <v-col sm="8" md="9" cols="12">
                <v-data-table
                    elevation="2"
                    :headers="headers"
                    :items="datos"
                    disable-sort
                    :footer-props="{
                        'items-per-page-options': [10, 20, 30, 40, 50]
                    }"
                    :options.sync="optionsTable"
                >

                <template v-slot:[`item.paciente`]="{ item }">
                        <div>{{item.paciente}}</div>
                        <div class="font-weight-bold">{{item.pacienteNombre}}</div>
                    </template>

                <template v-slot:[`item.urgencia`]="{ item }">
                        <v-icon color="red" v-if="item.urgencia">mdi-alert</v-icon>
                    </template>

                <template v-slot:[`item.status`]="{ item }">
                        <v-chip :color="getStatus(item.status).color">
                            <div class="white--text">{{getStatus(item.status).text}}</div>
                        </v-chip>
                    </template>

            </v-data-table>
            <inter-nueva
                :dialogModal.sync="interModal"
                @guardado="list()"
            ></inter-nueva>

            </v-col>
        </v-row>

    </v-sheet>
</template>

<script>
export default {
    components:{
        'select-personal':()=>import('@/components/com/SelectPersonal'),
        'inter-nueva':()=>import('@/views/interconsulta/InterconsultaNueva'),
    },
    async mounted(){
        this.list()
    },
    data:()=>({
        fechas:[],
        fechaArr:[],

        datos:[],
        headers:[
            {text:'', value:'urgencia', align:'center'},
            {text:'Folio', value:'folio', align:'center'},
            {text:'Paciente', value:'paciente'},
            {text:'Especialidad', value:'servicioDestino', align:'center'},
            {text:'Médico', value:'medicoRecibe', align:'center'},
            {text:'Estado', value:'status', width:'10%', align:'center'},
            {text:'', value:'view', width:'90px', align:'center'},
        ],
        loadingDatosTodos:false,
        totalRegistros:0,
        params:{},
        interModal:false,
    }),
    methods:{
        async list(){
            this.params = {}
            this.params = {...this.datosBusqueda}

            /*if (
                this.$store.getters['security/datosUsuario'].roles.includes('ROLE_CIRUGIA_MED') &&
                !this.$store.getters['security/datosUsuario'].roles.includes('ROLE_ADMIN')
            ){
                this.params.username = this.$store.getters['security/datosUsuario'].username
            }

            if (this.params.status >1 || !this.params.paciente){
                this.params.fechaADe=this.fechaArr[0]
                this.params.fechaAA=this.fechaArr[1]
            }

            if (this.params.status == 1){
                this.params.paciente = null
            }*/

            if (this.params.status){
                this.params.status = parseInt(this.params.status)
            }


            this.params.start=(this.optionsTable.page-1 )*this.optionsTable.itemsPerPage
            console.log(this.optionsTable.page)
            console.log(this.optionsTable.itemsPerPage)
            this.params.limit=this.optionsTable.itemsPerPage
            //let params={...this.optionsTable}

            this.loadingDatosTodos=true
            try {
                let req = await this.$http({
                    url: '/interconsulta/list',
                    method:'GET',
                    params: this.params,
                })
                //this.loadingDatosTodos=false
                this.datos = req.data.root
                this.totalRegistros = req.data.total
            } catch (err) {
                this.loadingDatosTodos=false
                this.$store.dispatch('security/revisaError',err)
            }
        },
        getStatus(tipo){
            let sta = {color:'black', text:'?'}
            switch (tipo){
                // 1: solicitada, 2:Atendida 99: cancelada
                case 1:
                    sta.text="Solicitada",
                    sta.color="blue"
                    break
                case 2:
                    sta.text="Atendida",
                    sta.color="green"
                    break
                case 99:
                    sta.text="Cancelada",
                    sta.color="black"
                    break
            }
            return sta
        },

    },
    computed:{
        datosBusqueda:{
            get(){
                return (this.$store.state.quirofano.datosBusqueda)
            },
            set(v){
                this.$store.commit('quirofano/ACTUALIZA_PARAMS', v)
            },
        },

        /*fechas:{
            get(){
                return (this.$store.state.quirofano.fechas)
            },
            set(v){
                this.$store.commit('quirofano/ACTUALIZA_FECHAS', v)
            },
        },

        fechaArr:{
            get(){
                return (this.$store.state.quirofano.fechaArr)
            },
            set(v){
                this.$store.commit('quirofano/ACTUALIZA_FECHAARR', v)
            },
        },*/
        optionsTable:{
            get(){
                return (this.$store.state.interconsulta.optionsTableList)
            },
            set(v){
                this.$store.commit('interconsulta/ACTUALIZA_OPTIONS_LIST', v)
            },
        },
        /*
        estaFecha(){
            return (this.moment(new Date()).format('DD/MM/YYYY'))
        },

        fechaDe(){
            return (this.getFecha(this.fechaArr[0]))
        },
        fechaA(){
            return (this.getFecha(this.fechaArr[1]))
        },*/
    },

    watch:{
        fechas(){
            this.list()
        },
        optionsTable: {
            handler () {
                this.list()
            },
            deep: true,
        },
        'datosBusqueda.status'(){
            this.optionsTable.page = 1
            this.list()
        },
        'datosBusqueda.folio'(){
            this.optionsTable.page=1
            this .list()
        },
        'datosBusqueda.paciente'(v){
            if (v >= 10000001){
                this.optionsTable.page = 1
                this.list()
            }
            if (!v){
                this.optionsTable.page = 1
                this.list()
            }
        }
    }
}
</script>

<style>

</style>